module.exports = __webpack_public_path__ + "img/icon-youtube.4601ea9a.svg";